module.exports = __webpack_public_path__ + "static/img/RAPS_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPS_1.png
// module id = xwim
// module chunks = 0